// Image sources for every card.
// Photos: Pexels CDN — real photos, consistent by ID, no API key needed.
// Colors / Shapes / Emotions: SVG data URIs — always render, never 404.

// Pexels: direct CDN link by photo ID — verified, reliable, relevant
const px = (id) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop`;

const colorBlock = (hex) =>
  `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect width="100" height="100" fill="#${hex}"/></svg>`
  )}`;

const shapeImg = (content) =>
  `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">${content}</svg>`
  )}`;

const face = (mouthD, browLeft = '', browRight = '', extras = '') =>
  shapeImg(
    `<circle cx="50" cy="50" r="48" fill="#FFD93D" stroke="#FFC107" stroke-width="2"/>
     <circle cx="35" cy="42" r="5.5" fill="#333"/>
     <circle cx="65" cy="42" r="5.5" fill="#333"/>
     ${browLeft}${browRight}
     <path d="${mouthD}" stroke="#333" stroke-width="3.5" fill="none" stroke-linecap="round"/>
     ${extras}`
  );

const v = (id, label, image, backup) => ({ id, label, image, backup });

const colorVars = (hex, id) => [
  v(`${id}-v1`, 'Color Block',  colorBlock(hex), colorBlock(hex)),
  v(`${id}-v2`, 'Color Circle', shapeImg(`<circle cx="50" cy="50" r="44" fill="#${hex}"/>`), colorBlock(hex)),
  v(`${id}-v3`, 'Color Star',   shapeImg(`<polygon points="50,5 61,35 95,35 68,57 79,91 50,70 21,91 32,57 5,35 39,35" fill="#${hex}"/>`), colorBlock(hex)),
];

export const CARD_IMAGES = {

  // ── Food ─────────────────────────────────────────────────────────────────
  Apple: {
    src: px(31663870), backup: px(12003423),
    variations: [
      v('apple-1', 'Apple', px(8286692),  px(209439)),
      v('apple-2', 'Apple', px(9603308),  px(37311194)),
      v('apple-3', 'Apple', px(12955951), px(162709)),
    ],
  },
  Banana: {
    src: px(26648783), backup: px(26648784),
    variations: [
      v('banana-1', 'Banana', px(31374536), px(61127)),
      v('banana-2', 'Banana', px(4399936),  px(32857517)),
      v('banana-3', 'Banana', px(15222230), px(26697896)),
    ],
  },
  Orange: {
    src: px(7960508), backup: px(9108283),
    variations: [
      v('orange-1', 'Orange', px(4030384),  px(11065671)),
      v('orange-2', 'Orange', px(2661834),  px(4033029)),
      v('orange-3', 'Orange', px(18452311), px(9108253)),
    ],
  },
  Grapes: {
    src: px(10922960), backup: px(9840058),
    variations: [
      v('grapes-1', 'Grapes', px(29195196), px(6489360)),
      v('grapes-2', 'Grapes', px(33344322), px(6844554)),
      v('grapes-3', 'Grapes', px(4216438),  px(8571713)),
    ],
  },
  Strawberry: {
    src: px(9717982), backup: px(1998893),
    variations: [
      v('straw-1', 'Strawberry', px(1350964),  px(12992363)),
      v('straw-2', 'Strawberry', px(31020869), px(4038801)),
      v('straw-3', 'Strawberry', px(4828536),  px(934055)),
    ],
  },
  Watermelon: {
    src: px(1591183), backup: px(3513238),
    variations: [
      v('wm-1', 'Watermelon', px(12932797), px(3429784)),
      v('wm-2', 'Watermelon', px(2865987),  px(5460885)),
      v('wm-3', 'Watermelon', px(26950757), px(27035208)),
    ],
  },
  Pineapple: {
    src: px(37284807), backup: px(30893237),
    variations: [
      v('pine-1', 'Pineapple', px(7194817),  px(13835776)),
      v('pine-2', 'Pineapple', px(12471181), px(139258)),
      v('pine-3', 'Pineapple', px(189264),   px(5945898)),
    ],
  },
  Mango: {
    src: px(30893290), backup: px(37681139),
    variations: [
      v('mango-1', 'Mango', px(16038612), px(30893227)),
      v('mango-2', 'Mango', px(9219974),  px(36877895)),
      v('mango-3', 'Mango', px(2294471),  px(7543169)),
    ],
  },
  Peach: {
    src: px(9306017), backup: px(29727347),
    variations: [
      v('peach-1', 'Peach', px(27429847), px(8676230)),
      v('peach-2', 'Peach', px(11063842), px(10846675)),
      v('peach-3', 'Peach', px(29727350), px(8754410)),
    ],
  },
  Pear: {
    src: px(31024461), backup: px(36938844),
    variations: [
      v('pear-1', 'Pear', px(6431030),  px(31024463)),
      v('pear-2', 'Pear', px(7636165),  px(13536243)),
      v('pear-3', 'Pear', px(30637587), px(11477745)),
    ],
  },
  Cherry: {
    src: px(9286808), backup: px(1149021),
    variations: [
      v('cherry-1', 'Cherry', px(9304635),  px(8720836)),
      v('cherry-2', 'Cherry', px(8973374),  px(12328613)),
      v('cherry-3', 'Cherry', px(12414331), px(33328094)),
    ],
  },
  Blueberry: {
    src: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/food/blueberry-1.png',
    backup: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/food/blueberry-2.png',
    variations: [
      v('blue-1', 'Blueberry', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/food/blueberry-3.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/food/blueberry-5.png'),
      v('blue-2', 'Blueberry', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/food/blueberry-4.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/food/blueberry-6.png'),
      v('blue-3', 'Blueberry', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/food/blueberry-6.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/food/blueberry-3.png'),
    ],
  },
  Pizza: {
    src: px(6068717), backup: px(9993754),
    variations: [
      v('pizza-1', 'Pizza', px(31596394), px(32763320)),
      v('pizza-2', 'Pizza', px(5903389),  px(9685264)),
      v('pizza-3', 'Pizza', px(5903382),  px(24513338)),
    ],
  },
  Burger: {
    src: px(27988502), backup: px(18354206),
    variations: [
      v('burger-1', 'Burger', px(2128536),  px(15344191)),
      v('burger-2', 'Burger', px(3764353),  px(15007048)),
      v('burger-3', 'Burger', px(1938272),  px(2267538)),
    ],
  },
  Sandwich: {
    src: px(28396784), backup: px(11256670),
    variations: [
      v('sand-1', 'Sandwich', px(19202829), px(34452166)),
      v('sand-2', 'Sandwich', px(9240536),  px(19202817)),
      v('sand-3', 'Sandwich', px(15362507), px(6416558)),
    ],
  },
  'Hot Dog': {
    src: px(36501070), backup: px(12123654),
    variations: [
      v('hdog-1', 'Hot Dog', px(4113454), px(4113470)),
      v('hdog-2', 'Hot Dog', px(4113501), px(37308548)),
      v('hdog-3', 'Hot Dog', px(27668694),px(25388980)),
    ],
  },
  Taco: {
    src: px(18574183), backup: px(18574186),
    variations: [
      v('taco-1', 'Taco', px(4958779), px(5837188)),
      v('taco-2', 'Taco', px(5837196), px(7041784)),
      v('taco-3', 'Taco', px(4958530), px(5837105)),
    ],
  },
  Sushi: {
    src: px(28291554), backup: px(17894270),
    variations: [
      v('sushi-1', 'Sushi', px(37260671), px(17894247)),
      v('sushi-2', 'Sushi', px(28291553), px(28291549)),
      v('sushi-3', 'Sushi', px(28291552), px(36317039)),
    ],
  },
  Pasta: {
    src: px(4518806), backup: px(6287376),
    variations: [
      v('pasta-1', 'Pasta', px(4518796),  px(6294418)),
      v('pasta-2', 'Pasta', px(26207761), px(4518802)),
      v('pasta-3', 'Pasta', px(4903734),  px(6287535)),
    ],
  },
  Salad: {
    src: px(13630358), backup: px(842545),
    variations: [
      v('salad-1', 'Salad', px(13350113), px(4958946)),
      v('salad-2', 'Salad', px(29582941), px(13788174)),
      v('salad-3', 'Salad', px(29843061), px(10665501)),
    ],
  },
  Soup: {
    src: px(8054777), backup: px(15403396),
    variations: [
      v('soup-1', 'Soup', px(30857414), px(6896516)),
      v('soup-2', 'Soup', px(15486347), px(14774696)),
      v('soup-3', 'Soup', px(6246099),  px(28678619)),
    ],
  },
  Bread: {
    src: px(209206), backup: px(4203052),
    variations: [
      v('bread-1', 'Bread', px(33658043), px(35047344)),
      v('bread-2', 'Bread', px(28354523), px(33658033)),
      v('bread-3', 'Bread', px(4198358),  px(1383908)),
    ],
  },
  Cookie: {
    src: px(31116124), backup: px(8081574),
    variations: [
      v('cookie-1', 'Cookie', px(30759934), px(298485)),
      v('cookie-2', 'Cookie', px(36446733), px(15014922)),
      v('cookie-3', 'Cookie', px(8081573),  px(36500580)),
    ],
  },
  Cake: {
    src: px(32333371), backup: px(23384637),
    variations: [
      v('cake-1', 'Cake', px(12616001), px(33759172)),
      v('cake-2', 'Cake', px(25956380), px(7330772)),
      v('cake-3', 'Cake', px(369267),   px(7159595)),
    ],
  },
  'Ice Cream': {
    src: px(7761650), backup: px(15595674),
    variations: [
      v('ice-1', 'Ice Cream', px(16962446), px(4725717)),
      v('ice-2', 'Ice Cream', px(20988473), px(1666635)),
      v('ice-3', 'Ice Cream', px(8093182),  px(9227955)),
    ],
  },
  Cheese: {
    src: px(3693280), backup: px(34037769),
    variations: [
      v('cheese-1', 'Cheese', px(36791070), px(3693283)),
      v('cheese-2', 'Cheese', px(11065345), px(8360244)),
      v('cheese-3', 'Cheese', px(37338215), px(793129)),
    ],
  },
  Pork: {
    src: px(7333262), backup: px(5500663),
    variations: [
      v('pork-1', 'Pork', px(7333258),  px(7333266)),
      v('pork-2', 'Pork', px(10647859), px(12473311)),
      v('pork-3', 'Pork', px(20527110), px(332784)),
    ],
  },

  // ── Animals ───────────────────────────────────────────────────────────────
  Dog: {
    src: px(31203405), backup: px(34756098),
    variations: [
      v('dog-1', 'Dog', px(7801145), px(5561399)),
      v('dog-2', 'Dog', px(568019),  px(6253965)),
      v('dog-3', 'Dog', px(15275503),px(4422100)),
    ],
  },
  Cat: {
    src: px(6864659), backup: px(34388974),
    variations: [
      v('cat-1', 'Cat', px(36072890), px(31915254)),
      v('cat-2', 'Cat', px(15383017), px(19119158)),
      v('cat-3', 'Cat', px(10874678), px(12155842)),
    ],
  },
  Horse: {
    src: px(30287738), backup: px(32708360),
    variations: [
      v('horse-1', 'Horse', px(27910216), px(12127017)),
      v('horse-2', 'Horse', px(31076278), px(30803625)),
      v('horse-3', 'Horse', px(26556137), px(28483510)),
    ],
  },
  Elephant: {
    src: px(25754094), backup: px(35671096),
    variations: [
      v('eleph-1', 'Elephant', px(3739327),  px(35671094)),
      v('eleph-2', 'Elephant', px(17103710), px(27116276)),
      v('eleph-3', 'Elephant', px(11870159), px(29480531)),
    ],
  },
  Bird: {
    src: px(30583571), backup: px(31719656),
    variations: [
      v('bird-1', 'Bird', px(28312507), px(30174893)),
      v('bird-2', 'Bird', px(33361091), px(32316498)),
      v('bird-3', 'Bird', px(36208720), px(29275539)),
    ],
  },
  Fish: {
    src: px(12245114), backup: px(12246532),
    variations: [
      v('fish-1', 'Fish', px(19680232), px(37431486)),
      v('fish-2', 'Fish', px(31956913), px(31956915)),
      v('fish-3', 'Fish', px(7254919),  px(30717712)),
    ],
  },
  Bear: {
    src: px(18453573), backup: px(3048718),
    variations: [
      v('bear-1', 'Bear', px(14431197), px(10172222)),
      v('bear-2', 'Bear', px(37533536), px(19140962)),
      v('bear-3', 'Bear', px(4282463),  px(34799366)),
    ],
  },
  Rabbit: {
    src: px(31778632), backup: px(5766548),
    variations: [
      v('rab-1', 'Rabbit', px(35983095), px(30197040)),
      v('rab-2', 'Rabbit', px(16456443), px(27503633)),
      v('rab-3', 'Rabbit', px(11702024), px(17502933)),
    ],
  },
  Lion: {
    src: px(11838539), backup: px(32196368),
    variations: [
      v('lion-1', 'Lion', px(37075683), px(14855062)),
      v('lion-2', 'Lion', px(32420357), px(32420367)),
      v('lion-3', 'Lion', px(32420365), px(37075691)),
    ],
  },
  Tiger: {
    src: px(27834738), backup: px(27834731),
    variations: [
      v('tiger-1', 'Tiger', px(27834727), px(27834726)),
      v('tiger-2', 'Tiger', px(36530920), px(37426136)),
      v('tiger-3', 'Tiger', px(27834733), px(17213816)),
    ],
  },
  Giraffe: {
    src: px(35283497), backup: px(17069651),
    variations: [
      v('giraffe-1', 'Giraffe', px(33650610), px(26582999)),
      v('giraffe-2', 'Giraffe', px(21875079), px(21875080)),
      v('giraffe-3', 'Giraffe', px(16982583), px(4577493)),
    ],
  },
  Monkey: {
    src: px(29536864), backup: px(28399269),
    variations: [
      v('monkey-1', 'Monkey', px(18612371), px(32230138)),
      v('monkey-2', 'Monkey', px(13013205), px(3493731)),
      v('monkey-3', 'Monkey', px(34581227), px(36485352)),
    ],
  },
  Cow: {
    src: px(37692161), backup: px(29468422),
    variations: [
      v('cow-1', 'Cow', px(16846562), px(10041350)),
      v('cow-2', 'Cow', px(17765401), px(8894754)),
      v('cow-3', 'Cow', px(12381458), px(5216140)),
    ],
  },
  Pig: {
    src: px(8839927), backup: px(20729021),
    variations: [
      v('pig-1', 'Pig', px(2252541),  px(6791938)),
      v('pig-2', 'Pig', px(2737171),  px(29738145)),
      v('pig-3', 'Pig', px(29738146), px(2737175)),
    ],
  },
  Sheep: {
    src: px(9348503), backup: px(317333),
    variations: [
      v('sheep-1', 'Sheep', px(32852249), px(9822671)),
      v('sheep-2', 'Sheep', px(17843111), px(30425108)),
      v('sheep-3', 'Sheep', px(30721323), px(5490698)),
    ],
  },
  Duck: {
    src: px(11954259), backup: px(7201421),
    variations: [
      v('duck-1', 'Duck', px(19382413), px(12364211)),
      v('duck-2', 'Duck', px(9139987),  px(34680775)),
      v('duck-3', 'Duck', px(27084456), px(27400861)),
    ],
  },
  Frog: {
    src: px(28074794), backup: px(20831274),
    variations: [
      v('frog-1', 'Frog', px(12680116), px(31747387)),
      v('frog-2', 'Frog', px(18453598), px(21327284)),
      v('frog-3', 'Frog', px(18373851), px(17506297)),
    ],
  },
  Turtle: {
    src: px(36132584), backup: px(4767913),
    variations: [
      v('turtle-1', 'Turtle', px(20443161), px(10498909)),
      v('turtle-2', 'Turtle', px(12173784), px(5277692)),
      v('turtle-3', 'Turtle', px(4591716),  px(6310392)),
    ],
  },
  Penguin: {
    src: px(36732837), backup: px(20413999),
    variations: [
      v('peng-1', 'Penguin', px(36746837), px(36732836)),
      v('peng-2', 'Penguin', px(36746836), px(10147418)),
      v('peng-3', 'Penguin', px(7315070),  px(36732833)),
    ],
  },
  Dolphin: {
    src: px(19005210), backup: px(11342081),
    variations: [
      v('dolph-1', 'Dolphin', px(33713322), px(11335851)),
      v('dolph-2', 'Dolphin', px(32585950), px(3439576)),
      v('dolph-3', 'Dolphin', px(19505130), px(30405220)),
    ],
  },

  // ── Colors (SVG color blocks + shape variations) ──────────────────────────
  Red:         { src: colorBlock('E53935'), backup: colorBlock('FF0000'), variations: colorVars('E53935', 'red') },
  Blue:        { src: colorBlock('1E88E5'), backup: colorBlock('0000FF'), variations: colorVars('1E88E5', 'blue') },
  Yellow:      { src: colorBlock('FDD835'), backup: colorBlock('FFFF00'), variations: colorVars('FDD835', 'yellow') },
  Green:       { src: colorBlock('43A047'), backup: colorBlock('008000'), variations: colorVars('43A047', 'green') },
  OrangeColor: { src: colorBlock('FB8C00'), backup: colorBlock('FFA500'), variations: colorVars('FB8C00', 'orange') },
  Purple:      { src: colorBlock('8E24AA'), backup: colorBlock('800080'), variations: colorVars('8E24AA', 'purple') },
  Pink:        { src: colorBlock('E91E63'), backup: colorBlock('FF69B4'), variations: colorVars('E91E63', 'pink') },
  Brown:       { src: colorBlock('6D4C41'), backup: colorBlock('8B4513'), variations: colorVars('6D4C41', 'brown') },
  Black:       { src: colorBlock('212121'), backup: colorBlock('000000'), variations: colorVars('212121', 'black') },
  White:       { src: colorBlock('F5F5F5'), backup: colorBlock('FFFFFF'), variations: colorVars('F5F5F5', 'white') },
  Gray:        { src: colorBlock('757575'), backup: colorBlock('808080'), variations: colorVars('757575', 'gray') },

  // ── Shapes (SVG — same shape in 3 colors) ────────────────────────────────
  Circle: {
    src: shapeImg('<circle cx="50" cy="50" r="44" fill="#E53935" stroke="#C62828" stroke-width="3"/>'),
    backup: shapeImg('<circle cx="50" cy="50" r="44" fill="#E53935"/>'),
    variations: [
      v('circle-v1', 'Red Circle',    shapeImg('<circle cx="50" cy="50" r="44" fill="#E53935" stroke="#C62828" stroke-width="3"/>'), null),
      v('circle-v2', 'Blue Circle',   shapeImg('<circle cx="50" cy="50" r="44" fill="#1E88E5" stroke="#1565C0" stroke-width="3"/>'), null),
      v('circle-v3', 'Yellow Circle', shapeImg('<circle cx="50" cy="50" r="44" fill="#FDD835" stroke="#F9A825" stroke-width="3"/>'), null),
    ],
  },
  Square: {
    src: shapeImg('<rect x="6" y="6" width="88" height="88" fill="#1E88E5" stroke="#1565C0" stroke-width="3"/>'),
    backup: shapeImg('<rect x="6" y="6" width="88" height="88" fill="#1E88E5"/>'),
    variations: [
      v('square-v1', 'Blue Square',  shapeImg('<rect x="6" y="6" width="88" height="88" fill="#1E88E5" stroke="#1565C0" stroke-width="3"/>'), null),
      v('square-v2', 'Red Square',   shapeImg('<rect x="6" y="6" width="88" height="88" fill="#E53935" stroke="#C62828" stroke-width="3"/>'), null),
      v('square-v3', 'Green Square', shapeImg('<rect x="6" y="6" width="88" height="88" fill="#43A047" stroke="#2E7D32" stroke-width="3"/>'), null),
    ],
  },
  Triangle: {
    src: shapeImg('<polygon points="50,5 95,93 5,93" fill="#43A047" stroke="#2E7D32" stroke-width="3"/>'),
    backup: shapeImg('<polygon points="50,5 95,93 5,93" fill="#43A047"/>'),
    variations: [
      v('tri-v1', 'Green Triangle',  shapeImg('<polygon points="50,5 95,93 5,93" fill="#43A047" stroke="#2E7D32" stroke-width="3"/>'), null),
      v('tri-v2', 'Yellow Triangle', shapeImg('<polygon points="50,5 95,93 5,93" fill="#FDD835" stroke="#F9A825" stroke-width="3"/>'), null),
      v('tri-v3', 'Red Triangle',    shapeImg('<polygon points="50,5 95,93 5,93" fill="#E53935" stroke="#C62828" stroke-width="3"/>'), null),
    ],
  },
  Star: {
    src: shapeImg('<polygon points="50,5 61,35 95,35 68,57 79,91 50,70 21,91 32,57 5,35 39,35" fill="#FDD835" stroke="#F9A825" stroke-width="2"/>'),
    backup: shapeImg('<polygon points="50,5 61,35 95,35 68,57 79,91 50,70 21,91 32,57 5,35 39,35" fill="#FDD835"/>'),
    variations: [
      v('star-v1', 'Yellow Star', shapeImg('<polygon points="50,5 61,35 95,35 68,57 79,91 50,70 21,91 32,57 5,35 39,35" fill="#FDD835" stroke="#F9A825" stroke-width="2"/>'), null),
      v('star-v2', 'Red Star',    shapeImg('<polygon points="50,5 61,35 95,35 68,57 79,91 50,70 21,91 32,57 5,35 39,35" fill="#E53935" stroke="#C62828" stroke-width="2"/>'), null),
      v('star-v3', 'Blue Star',   shapeImg('<polygon points="50,5 61,35 95,35 68,57 79,91 50,70 21,91 32,57 5,35 39,35" fill="#1E88E5" stroke="#1565C0" stroke-width="2"/>'), null),
    ],
  },
  Heart: {
    src: shapeImg('<path d="M50,82 C10,56 8,18 30,10 C40,6 48,14 50,22 C52,14 60,6 70,10 C92,18 90,56 50,82 Z" fill="#E91E63" stroke="#C2185B" stroke-width="2"/>'),
    backup: shapeImg('<path d="M50,82 C10,56 8,18 30,10 C40,6 48,14 50,22 C52,14 60,6 70,10 C92,18 90,56 50,82 Z" fill="#E91E63"/>'),
    variations: [
      v('heart-v1', 'Pink Heart',   shapeImg('<path d="M50,82 C10,56 8,18 30,10 C40,6 48,14 50,22 C52,14 60,6 70,10 C92,18 90,56 50,82 Z" fill="#E91E63" stroke="#C2185B" stroke-width="2"/>'), null),
      v('heart-v2', 'Red Heart',    shapeImg('<path d="M50,82 C10,56 8,18 30,10 C40,6 48,14 50,22 C52,14 60,6 70,10 C92,18 90,56 50,82 Z" fill="#E53935" stroke="#C62828" stroke-width="2"/>'), null),
      v('heart-v3', 'Purple Heart', shapeImg('<path d="M50,82 C10,56 8,18 30,10 C40,6 48,14 50,22 C52,14 60,6 70,10 C92,18 90,56 50,82 Z" fill="#8E24AA" stroke="#6A1B9A" stroke-width="2"/>'), null),
    ],
  },
  Diamond: {
    src: shapeImg('<polygon points="50,5 93,50 50,95 7,50" fill="#8E24AA" stroke="#6A1B9A" stroke-width="3"/>'),
    backup: shapeImg('<polygon points="50,5 93,50 50,95 7,50" fill="#8E24AA"/>'),
    variations: [
      v('diamond-v1', 'Purple Diamond', shapeImg('<polygon points="50,5 93,50 50,95 7,50" fill="#8E24AA" stroke="#6A1B9A" stroke-width="3"/>'), null),
      v('diamond-v2', 'Blue Diamond',   shapeImg('<polygon points="50,5 93,50 50,95 7,50" fill="#1E88E5" stroke="#1565C0" stroke-width="3"/>'), null),
      v('diamond-v3', 'Red Diamond',    shapeImg('<polygon points="50,5 93,50 50,95 7,50" fill="#E53935" stroke="#C62828" stroke-width="3"/>'), null),
    ],
  },
  Rectangle: {
    src: shapeImg('<rect x="6" y="22" width="88" height="56" fill="#00897B" stroke="#00695C" stroke-width="3"/>'),
    backup: shapeImg('<rect x="6" y="22" width="88" height="56" fill="#00897B"/>'),
    variations: [
      v('rect-v1', 'Green Rectangle', shapeImg('<rect x="6" y="22" width="88" height="56" fill="#00897B" stroke="#00695C" stroke-width="3"/>'), null),
      v('rect-v2', 'Blue Rectangle',  shapeImg('<rect x="6" y="22" width="88" height="56" fill="#1E88E5" stroke="#1565C0" stroke-width="3"/>'), null),
      v('rect-v3', 'Red Rectangle',   shapeImg('<rect x="6" y="22" width="88" height="56" fill="#E53935" stroke="#C62828" stroke-width="3"/>'), null),
    ],
  },
  Oval: {
    src: shapeImg('<ellipse cx="50" cy="50" rx="44" ry="28" fill="#FB8C00" stroke="#E65100" stroke-width="3"/>'),
    backup: shapeImg('<ellipse cx="50" cy="50" rx="44" ry="28" fill="#FB8C00"/>'),
    variations: [
      v('oval-v1', 'Orange Oval', shapeImg('<ellipse cx="50" cy="50" rx="44" ry="28" fill="#FB8C00" stroke="#E65100" stroke-width="3"/>'), null),
      v('oval-v2', 'Blue Oval',   shapeImg('<ellipse cx="50" cy="50" rx="44" ry="28" fill="#1E88E5" stroke="#1565C0" stroke-width="3"/>'), null),
      v('oval-v3', 'Green Oval',  shapeImg('<ellipse cx="50" cy="50" rx="44" ry="28" fill="#43A047" stroke="#2E7D32" stroke-width="3"/>'), null),
    ],
  },
  Pentagon: {
    src: shapeImg('<polygon points="50,5 95,36 77,91 23,91 5,36" fill="#1E88E5" stroke="#1565C0" stroke-width="3"/>'),
    backup: shapeImg('<polygon points="50,5 95,36 77,91 23,91 5,36" fill="#1E88E5"/>'),
    variations: [
      v('pent-v1', 'Blue Pentagon',   shapeImg('<polygon points="50,5 95,36 77,91 23,91 5,36" fill="#1E88E5" stroke="#1565C0" stroke-width="3"/>'), null),
      v('pent-v2', 'Green Pentagon',  shapeImg('<polygon points="50,5 95,36 77,91 23,91 5,36" fill="#43A047" stroke="#2E7D32" stroke-width="3"/>'), null),
      v('pent-v3', 'Purple Pentagon', shapeImg('<polygon points="50,5 95,36 77,91 23,91 5,36" fill="#8E24AA" stroke="#6A1B9A" stroke-width="3"/>'), null),
    ],
  },
  Hexagon: {
    src: shapeImg('<polygon points="50,5 91,27 91,73 50,95 9,73 9,27" fill="#FDD835" stroke="#F9A825" stroke-width="3"/>'),
    backup: shapeImg('<polygon points="50,5 91,27 91,73 50,95 9,73 9,27" fill="#FDD835"/>'),
    variations: [
      v('hex-v1', 'Yellow Hexagon', shapeImg('<polygon points="50,5 91,27 91,73 50,95 9,73 9,27" fill="#FDD835" stroke="#F9A825" stroke-width="3"/>'), null),
      v('hex-v2', 'Orange Hexagon', shapeImg('<polygon points="50,5 91,27 91,73 50,95 9,73 9,27" fill="#FB8C00" stroke="#E65100" stroke-width="3"/>'), null),
      v('hex-v3', 'Blue Hexagon',   shapeImg('<polygon points="50,5 91,27 91,73 50,95 9,73 9,27" fill="#1E88E5" stroke="#1565C0" stroke-width="3"/>'), null),
    ],
  },

  // ── Emotions (real Pexels photos of human facial expressions) ────────────
  Happy: {
    src: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/happy-2.png',
    backup: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/happy-6.png',
    variations: [
      v('happy-v1', 'Happy', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/happy-1.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/happy-4.png'),
      v('happy-v2', 'Happy', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/happy-3.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/happy-6.png'),
      v('happy-v3', 'Happy', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/happy-5.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/happy-4.png'),
    ],
  },
  Sad: {
    src: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/sad-5.png',
    backup: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/sad-3.png',
    variations: [
      v('sad-v1', 'Sad', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/sad-2.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/sad-6.png'),
      v('sad-v2', 'Sad', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/sad-1.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/sad-4.png'),
      v('sad-v3', 'Sad', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/sad-4.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/sad-2.png'),
    ],
  },
  Angry: {
    src: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/angry-5.png',
    backup: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/angry-1.png',
    variations: [
      v('angry-v1', 'Angry', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/angry-2.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/angry-6.png'),
      v('angry-v2', 'Angry', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/angry-3.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/angry-4.png'),
      v('angry-v3', 'Angry', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/angry-4.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/angry-2.png'),
    ],
  },
  Surprised: {
    src: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/surprised-2.png',
    backup: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/surprised-1.png',
    variations: [
      v('surp-v1', 'Surprised', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/surprised-4.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/surprised-6.png'),
      v('surp-v2', 'Surprised', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/surprised-5.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/surprised-3.png'),
      v('surp-v3', 'Surprised', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/surprised-6.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/emotions/surprised-3.png'),
    ],
  },
  Scared: {
    src: px(20195206), backup: px(1930529),
    variations: [
      v('scare-v1', 'Scared', px(20195206), px(1930529)),
      v('scare-v2', 'Scared', px(1930529),  px(5700162)),
      v('scare-v3', 'Scared', px(5700162),  px(20195206)),
    ],
  },
  Excited: {
    src: px(32595507), backup: px(3763588),
    variations: [
      v('excit-v1', 'Excited', px(32595507), px(3763588)),
      v('excit-v2', 'Excited', px(3763588),  px(4473809)),
      v('excit-v3', 'Excited', px(4473809),  px(32595507)),
    ],
  },
  Confused: {
    src: px(8346921), backup: px(2380794),
    variations: [
      v('conf-v1', 'Confused', px(8346921), px(2380794)),
      v('conf-v2', 'Confused', px(2380794), px(3958818)),
      v('conf-v3', 'Confused', px(3958818), px(8346921)),
    ],
  },
  Silly: {
    src: px(3799761), backup: px(3785842),
    variations: [
      v('silly-v1', 'Silly', px(3799761),  px(3785842)),
      v('silly-v2', 'Silly', px(3785842),  px(34988575)),
      v('silly-v3', 'Silly', px(34988575), px(3799761)),
    ],
  },
  Tired: {
    src: px(8867225), backup: px(7927575),
    variations: [
      v('tired-v1', 'Tired', px(8867225), px(7927575)),
      v('tired-v2', 'Tired', px(7927575), px(6624300)),
      v('tired-v3', 'Tired', px(6624300), px(8867225)),
    ],
  },
  Proud: {
    src: px(2379004), backup: px(7221513),
    variations: [
      v('proud-v1', 'Proud', px(2379004),  px(7221513)),
      v('proud-v2', 'Proud', px(7221513),  px(33393733)),
      v('proud-v3', 'Proud', px(33393733), px(2379004)),
    ],
  },

  // ── Actions ───────────────────────────────────────────────────────────────
  Running: {
    src: px(8454909), backup: px(5634121),
    variations: [
      v('run-1', 'Running', px(8454909),  px(5634121)),
      v('run-2', 'Running', px(5634121),  px(18408962)),
      v('run-3', 'Running', px(4604846),  px(5961848)),
    ],
  },
  Jumping: {
    src: px(13545890), backup: px(5488827),
    variations: [
      v('jump-1', 'Jumping', px(13545890), px(5488827)),
      v('jump-2', 'Jumping', px(15114042), px(1848662)),
      v('jump-3', 'Jumping', px(2387712),  px(5639931)),
    ],
  },
  Eating: {
    src: px(7129440), backup: px(7129430),
    variations: [
      v('eat-1', 'Eating', px(7129522), px(7129446)),
      v('eat-2', 'Eating', px(8430635), px(7129453)),
      v('eat-3', 'Eating', px(6550791), px(7129452)),
    ],
  },
  Reading: {
    src: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/actions/reading-1.png',
    backup: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/actions/reading-2.png',
    variations: [
      v('read-1', 'Reading', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/actions/reading-3.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/actions/reading-5.png'),
      v('read-2', 'Reading', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/actions/reading-5.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/actions/reading-6.png'),
      v('read-3', 'Reading', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/actions/reading-6.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/actions/reading-4.png'),
    ],
  },
  Sleeping: {
    src: px(55639), backup: px(7504928),
    variations: [
      v('sleep-1', 'Sleeping', px(5801247), px(5801243)),
      v('sleep-2', 'Sleeping', px(3887596), px(10566196)),
      v('sleep-3', 'Sleeping', px(4815380), px(10566190)),
    ],
  },
  Dancing: {
    src: px(18812920), backup: px(2114365),
    variations: [
      v('dance-1', 'Dancing', px(18812920), px(2114365)),
      v('dance-2', 'Dancing', px(2114365),  px(209948)),
      v('dance-3', 'Dancing', px(209948),   px(7481276)),
    ],
  },
  Swimming: {
    src: px(260598), backup: px(6011892),
    variations: [
      v('swim-1', 'Swimming', px(260598),  px(6011892)),
      v('swim-2', 'Swimming', px(5193475), px(1044298)),
      v('swim-3', 'Swimming', px(52988),   px(2408832)),
    ],
  },
  Drawing: {
    src: px(8612983), backup: px(9872291),
    variations: [
      v('draw-1', 'Drawing', px(8612983),  px(9872291)),
      v('draw-2', 'Drawing', px(9872291),  px(8382373)),
      v('draw-3', 'Drawing', px(20118365), px(8612983)),
    ],
  },
  Clapping: {
    src: px(5212700), backup: px(8035137),
    variations: [
      v('clap-1', 'Clapping', px(5212700),  px(8035137)),
      v('clap-2', 'Clapping', px(8035137),  px(35250395)),
      v('clap-3', 'Clapping', px(35250395), px(10565586)),
    ],
  },
  Waving: {
    src: px(5537576), backup: px(7878270),
    variations: [
      v('wave-1', 'Waving', px(5537576),  px(7878270)),
      v('wave-2', 'Waving', px(7878270),  px(14232911)),
      v('wave-3', 'Waving', px(14232911), px(5537576)),
    ],
  },

  // ── School ────────────────────────────────────────────────────────────────
  Book: {
    src: px(35972722), backup: px(3747502),
    variations: [
      v('book-1', 'Book', px(9095387),  px(35975197)),
      v('book-2', 'Book', px(5535288),  px(5009227)),
      v('book-3', 'Book', px(23833967), px(14154)),
    ],
  },
  Pencil: {
    src: px(8386693), backup: px(4853198),
    variations: [
      v('pencil-1', 'Pencil', px(30583224), px(4519860)),
      v('pencil-2', 'Pencil', px(4853177),  px(8386695)),
      v('pencil-3', 'Pencil', px(30663291), px(3444630)),
    ],
  },
  Backpack: {
    src: px(37580640), backup: px(37098586),
    variations: [
      v('bp-1', 'Backpack', px(5905436), px(8465442)),
      v('bp-2', 'Backpack', px(8617698), px(8423383)),
      v('bp-3', 'Backpack', px(8617629), px(7395291)),
    ],
  },
  Scissors: {
    src: px(6963009), backup: px(7695338),
    variations: [
      v('sci-1', 'Scissors', px(7695340), px(8250803)),
      v('sci-2', 'Scissors', px(5412107), px(8535172)),
      v('sci-3', 'Scissors', px(4219213), px(4219215)),
    ],
  },
  Ruler: {
    src: px(19585984), backup: px(6281140),
    variations: [
      v('ruler-1', 'Ruler', px(4919433),  px(35970041)),
      v('ruler-2', 'Ruler', px(162500),   px(37588632)),
      v('ruler-3', 'Ruler', px(29279398), px(7718657)),
    ],
  },
  Crayon: {
    src: px(8605023), backup: px(8593813),
    variations: [
      v('cray-1', 'Crayon', px(4480173), px(284082)),
      v('cray-2', 'Crayon', px(2078147), px(1915340)),
      v('cray-3', 'Crayon', px(261687),  px(9149206)),
    ],
  },
  Glue: {
    src: px(3787100), backup: px(28231726),
    variations: [
      v('glue-1', 'Glue', px(5691660), px(5088011)),
      v('glue-2', 'Glue', px(7014489), px(7695191)),
      v('glue-3', 'Glue', px(7695188), px(10607179)),
    ],
  },
  Eraser: {
    src: px(5705954), backup: px(5705983),
    variations: [
      v('eraser-1', 'Eraser', px(5705997), px(5705986)),
      v('eraser-2', 'Eraser', px(9743034), px(6193753)),
      v('eraser-3', 'Eraser', px(9743002), px(9743001)),
    ],
  },
  Marker: {
    src: px(32324492), backup: px(1152665),
    variations: [
      v('marker-1', 'Marker', px(19236197), px(36626612)),
      v('marker-2', 'Marker', px(2327071),  px(709626)),
      v('marker-3', 'Marker', px(4492447),  px(14197645)),
    ],
  },
  Chalkboard: {
    src: px(5407045), backup: px(36650154),
    variations: [
      v('chalk-1', 'Chalkboard', px(36159720), px(18541760)),
      v('chalk-2', 'Chalkboard', px(8500343),  px(7483131)),
      v('chalk-3', 'Chalkboard', px(31091590), px(6238050)),
    ],
  },

  // ── Vehicles ──────────────────────────────────────────────────────────────
  Car: {
    src: px(10314337), backup: px(19316821),
    variations: [
      v('car-1', 'Car', px(11439335), px(15167823)),
      v('car-2', 'Car', px(29522399), px(11045498)),
      v('car-3', 'Car', px(30287465), px(34762829)),
    ],
  },
  Bus: {
    src: px(9280251), backup: px(19760978),
    variations: [
      v('bus-1', 'Bus', px(14189236), px(7403924)),
      v('bus-2', 'Bus', px(32322673), px(14189248)),
      v('bus-3', 'Bus', px(5098028),  px(27662522)),
    ],
  },
  Airplane: {
    src: px(27670208), backup: px(37589299),
    variations: [
      v('plane-1', 'Airplane', px(19563698), px(31948024)),
      v('plane-2', 'Airplane', px(14482714), px(3374249)),
      v('plane-3', 'Airplane', px(12184094), px(35398973)),
    ],
  },
  Bicycle: {
    src: px(36546545), backup: px(10066135),
    variations: [
      v('bike-1', 'Bicycle', px(35689350), px(4814010)),
      v('bike-2', 'Bicycle', px(384472),   px(13012115)),
      v('bike-3', 'Bicycle', px(11292520), px(32403277)),
    ],
  },
  Truck: {
    src: px(6563903), backup: px(37538286),
    variations: [
      v('truck-1', 'Truck', px(33081220), px(12261472)),
      v('truck-2', 'Truck', px(27508769), px(8994766)),
      v('truck-3', 'Truck', px(37124290), px(11087837)),
    ],
  },
  Train: {
    src: px(11794146), backup: px(16435189),
    variations: [
      v('train-1', 'Train', px(32058302), px(12990331)),
      v('train-2', 'Train', px(33005805), px(14269127)),
      v('train-3', 'Train', px(16234305), px(26712403)),
    ],
  },
  Boat: {
    src: px(35030750), backup: px(35030752),
    variations: [
      v('boat-1', 'Boat', px(35030754), px(35030769)),
      v('boat-2', 'Boat', px(35030771), px(35030757)),
      v('boat-3', 'Boat', px(35030758), px(35030766)),
    ],
  },
  Motorcycle: {
    src: px(16330298), backup: px(32076462),
    variations: [
      v('moto-1', 'Motorcycle', px(35837783), px(9481684)),
      v('moto-2', 'Motorcycle', px(9949099),  px(35109256)),
      v('moto-3', 'Motorcycle', px(26936243), px(30794231)),
    ],
  },
  Helicopter: {
    src: px(35979809), backup: px(12564476),
    variations: [
      v('heli-1', 'Helicopter', px(35979815), px(13332578)),
      v('heli-2', 'Helicopter', px(9540676),  px(5756482)),
      v('heli-3', 'Helicopter', px(33996045), px(11727188)),
    ],
  },
  Ambulance: {
    src: px(5364345), backup: px(6519847),
    variations: [
      v('ambu-1', 'Ambulance', px(6519887),  px(28123697)),
      v('ambu-2', 'Ambulance', px(6520105),  px(21620549)),
      v('ambu-3', 'Ambulance', px(6519850),  px(11744954)),
    ],
  },

  // ── Body Parts (Pexels — verified, clear, child-appropriate) ─────────────────
  Eyes: {
    src: px(2440264), backup: px(4117653),
    variations: [
      v('eye-v1', 'Eyes', px(2440264),  px(4117653)),
      v('eye-v2', 'Eyes', px(5486205),  px(16625783)),
      v('eye-v3', 'Eyes', px(25070796), px(6153020)),
    ],
  },
  Hands: {
    src: px(2258248), backup: px(2258247),
    variations: [
      v('hand-v1', 'Hands', px(2258248), px(2258247)),
      v('hand-v2', 'Hands', px(1276357), px(7298695)),
      v('hand-v3', 'Hands', px(7298695), px(255527)),
    ],
  },
  Feet: {
    src: px(10601904), backup: px(2962008),
    variations: [
      v('feet-v1', 'Feet', px(10601904), px(2962008)),
      v('feet-v2', 'Feet', px(34135875), px(5793797)),
      v('feet-v3', 'Feet', px(4557469),  px(8530292)),
    ],
  },
  Mouth: {
    src: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/body-parts/mouth-2.png',
    backup: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/body-parts/mouth-1.png',
    variations: [
      v('mouth-v1', 'Mouth', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/body-parts/mouth-3.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/body-parts/mouth-5.png'),
      v('mouth-v2', 'Mouth', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/body-parts/mouth-5.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/body-parts/mouth-6.png'),
      v('mouth-v3', 'Mouth', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/body-parts/mouth-6.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/body-parts/mouth-3.png'),
    ],
  },
  Ears: {
    src: px(7298452), backup: px(7298656),
    variations: [
      v('ear-v1', 'Ears', px(7298452), px(7298656)),
      v('ear-v2', 'Ears', px(5556510), px(8092973)),
      v('ear-v3', 'Ears', px(374765),  px(13308389)),
    ],
  },
  Nose: {
    src: px(13765741), backup: px(7290081),
    variations: [
      v('nose-v1', 'Nose', px(13765741), px(7460707)),
      v('nose-v2', 'Nose', px(7290081),  px(7479590)),
      v('nose-v3', 'Nose', px(7479592),  px(1138531)),
    ],
  },

  // ── Clothing ──────────────────────────────────────────────────────────────
  Shirt: {
    src: px(5697197), backup: px(5253935),
    variations: [
      v('shirt-1', 'Shirt', px(12975963), px(6774170)),
      v('shirt-2', 'Shirt', px(7760552),  px(5697197)),
      v('shirt-3', 'Shirt', px(5253935),  px(12975963)),
    ],
  },
  Pants: {
    src: px(1598507), backup: px(1598504),
    variations: [
      v('pants-1', 'Pants', px(1598506), px(1598503)),
      v('pants-2', 'Pants', px(1598501), px(1598507)),
      v('pants-3', 'Pants', px(1598504), px(1598506)),
    ],
  },
  Shoes: {
    src: px(267301), backup: px(267302),
    variations: [
      v('shoes-1', 'Shoes', px(267303), px(267301)),
      v('shoes-2', 'Shoes', px(267302), px(267303)),
      v('shoes-3', 'Shoes', px(267301), px(267302)),
    ],
  },
  Hat: {
    src: px(36755672), backup: px(185765),
    variations: [
      v('hat-1', 'Hat', px(19272485), px(9913069)),
      v('hat-2', 'Hat', px(15227090), px(36755672)),
      v('hat-3', 'Hat', px(185765),   px(19272485)),
    ],
  },
  Jacket: {
    src: px(35145903), backup: px(19084527),
    variations: [
      v('jacket-1', 'Jacket', px(10699145), px(7880265)),
      v('jacket-2', 'Jacket', px(7270003),  px(35145903)),
      v('jacket-3', 'Jacket', px(19084527), px(10699145)),
    ],
  },
  Socks: {
    src: px(10563910), backup: px(15948085),
    variations: [
      v('socks-1', 'Socks', px(12932537), px(4495756)),
      v('socks-2', 'Socks', px(13535205), px(10563910)),
      v('socks-3', 'Socks', px(15948085), px(12932537)),
    ],
  },
  Dress: {
    src: px(20544951), backup: px(31772344),
    variations: [
      v('dress-1', 'Dress', px(6675408),  px(33897823)),
      v('dress-2', 'Dress', px(14741291), px(20544951)),
      v('dress-3', 'Dress', px(31772344), px(6675408)),
    ],
  },
  Shorts: {
    src: px(9353581), backup: px(27721736),
    variations: [
      v('shorts-1', 'Shorts', px(12803209), px(4881128)),
      v('shorts-2', 'Shorts', px(5225427),  px(9353581)),
      v('shorts-3', 'Shorts', px(27721736), px(12803209)),
    ],
  },
  Coat: {
    src: px(19800418), backup: px(8974263),
    variations: [
      v('coat-1', 'Coat', px(13212801), px(10365761)),
      v('coat-2', 'Coat', px(5801828),  px(19800418)),
      v('coat-3', 'Coat', px(8974263),  px(13212801)),
    ],
  },
  Boots: {
    src: px(36053889), backup: px(5385354),
    variations: [
      v('boots-1', 'Boots', px(4729488), px(6193775)),
      v('boots-2', 'Boots', px(4786126), px(36053889)),
      v('boots-3', 'Boots', px(5385354), px(4729488)),
    ],
  },

  // ── Household ─────────────────────────────────────────────────────────────
  Chair: {
    src: px(7193706), backup: px(13813929),
    variations: [
      v('chair-1', 'Chair', px(32562036), px(29917912)),
      v('chair-2', 'Chair', px(15917237), px(7193706)),
      v('chair-3', 'Chair', px(13813929), px(32562036)),
    ],
  },
  Table: {
    src: px(7538106), backup: px(10032374),
    variations: [
      v('table-1', 'Table', px(17057034), px(5472818)),
      v('table-2', 'Table', px(31258060), px(7538106)),
      v('table-3', 'Table', px(10032374), px(17057034)),
    ],
  },
  Bed: {
    src: px(1743229), backup: px(775219),
    variations: [
      v('bed-1', 'Bed', px(1743230), px(775220)),
      v('bed-2', 'Bed', px(775221),  px(1743228)),
      v('bed-3', 'Bed', px(1743229), px(775219)),
    ],
  },
  Lamp: {
    src: px(1112598), backup: px(1112599),
    variations: [
      v('lamp-1', 'Lamp', px(1112597), px(1112598)),
      v('lamp-2', 'Lamp', px(1112599), px(1112597)),
      v('lamp-3', 'Lamp', px(1112598), px(1112599)),
    ],
  },
  Door: {
    src: px(277559), backup: px(277560),
    variations: [
      v('door-1', 'Door', px(277558), px(277559)),
      v('door-2', 'Door', px(277560), px(277558)),
      v('door-3', 'Door', px(277559), px(277560)),
    ],
  },
  Cup: {
    src: px(7192236), backup: px(32225873),
    variations: [
      v('cup-1', 'Cup', px(15290393), px(6878196)),
      v('cup-2', 'Cup', px(32225873), px(7192236)),
      v('cup-3', 'Cup', px(6878196),  px(15290393)),
    ],
  },
  Plate: {
    src: px(1640777), backup: px(2097090),
    variations: [
      v('plate-1', 'Plate', px(1640778), px(2097091)),
      v('plate-2', 'Plate', px(2097090), px(1640777)),
      v('plate-3', 'Plate', px(1640776), px(1640778)),
    ],
  },
  Spoon: {
    src: px(4198755), backup: px(7438964),
    variations: [
      v('spoon-1', 'Spoon', px(4226876),  px(36905101)),
      v('spoon-2', 'Spoon', px(26595162), px(4198755)),
      v('spoon-3', 'Spoon', px(7438964),  px(4226876)),
    ],
  },
  Fork: {
    src: px(30259610), backup: px(3640669),
    variations: [
      v('fork-1', 'Fork', px(34803105), px(32207946)),
      v('fork-2', 'Fork', px(31559661), px(30259610)),
      v('fork-3', 'Fork', px(3640669),  px(34803105)),
    ],
  },
  Couch: {
    src: px(4740494), backup: px(20418771),
    variations: [
      v('couch-1', 'Couch', px(3105219), px(8987432)),
      v('couch-2', 'Couch', px(6580416), px(4740494)),
      v('couch-3', 'Couch', px(20418771),px(3105219)),
    ],
  },

  // ── Sports ────────────────────────────────────────────────────────────────
  Soccer: {
    src: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/soccer-1.png',
    backup: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/soccer-6.png',
    variations: [
      v('soccer-1', 'Soccer', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/soccer-4.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/soccer-6.png'),
      v('soccer-2', 'Soccer', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/soccer-5.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/soccer-1.png'),
      v('soccer-3', 'Soccer', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/soccer-3.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/soccer-2.png'),
    ],
  },
  Basketball: {
    src: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/basketball-1.png',
    backup: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/basketball-3.png',
    variations: [
      v('bball-1', 'Basketball', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/basketball-2.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/basketball-6.png'),
      v('bball-2', 'Basketball', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/basketball-5.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/basketball-4.png'),
      v('bball-3', 'Basketball', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/basketball-4.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/basketball-5.png'),
    ],
  },
  Football: {
    src: px(26707860), backup: px(9610113),
    variations: [
      v('foot-1', 'Football', px(9610109),  px(13142768)),
      v('foot-2', 'Football', px(10799811), px(26707860)),
      v('foot-3', 'Football', px(9610113),  px(9610109)),
    ],
  },
  Baseball: {
    src: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/baseball-1.png',
    backup: 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/baseball-6.png',
    variations: [
      v('base-1', 'Baseball', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/baseball-2.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/baseball-4.png'),
      v('base-2', 'Baseball', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/baseball-3.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/baseball-5.png'),
      v('base-3', 'Baseball', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/baseball-5.png', 'https://storage.googleapis.com/stimuli-central-5fe9c.firebasestorage.app/flashcards/sports/baseball-3.png'),
    ],
  },
  Tennis: {
    src: px(35214667), backup: px(30575115),
    variations: [
      v('ten-1', 'Tennis', px(10612276), px(3207474)),
      v('ten-2', 'Tennis', px(22931875), px(35214667)),
      v('ten-3', 'Tennis', px(30575115), px(10612276)),
    ],
  },
  Golf: {
    src: px(54123), backup: px(7758348),
    variations: [
      v('golf-1', 'Golf', px(37825484), px(9207749)),
      v('golf-2', 'Golf', px(6573247),  px(54123)),
      v('golf-3', 'Golf', px(7758348),  px(37825484)),
    ],
  },
  Volleyball: {
    src: px(28207837), backup: px(14953188),
    variations: [
      v('vball-1', 'Volleyball', px(12169045), px(12169310)),
      v('vball-2', 'Volleyball', px(30290766), px(28207837)),
      v('vball-3', 'Volleyball', px(14953188), px(12169045)),
    ],
  },
  Gymnastics: {
    src: px(6572567), backup: px(6572612),
    variations: [
      v('gym-1', 'Gymnastics', px(6571927),  px(14171760)),
      v('gym-2', 'Gymnastics', px(6571937),  px(6572567)),
      v('gym-3', 'Gymnastics', px(6572612),  px(6571927)),
    ],
  },
  Bowling: {
    src: px(7429770), backup: px(7429621),
    variations: [
      v('bowl-1', 'Bowling', px(9273055), px(7429717)),
      v('bowl-2', 'Bowling', px(7429507), px(7429770)),
      v('bowl-3', 'Bowling', px(7429621), px(9273055)),
    ],
  },
  Hockey: {
    src: px(6469035), backup: px(20584514),
    variations: [
      v('hock-1', 'Hockey', px(34383777), px(6557325)),
      v('hock-2', 'Hockey', px(6468928),  px(6469035)),
      v('hock-3', 'Hockey', px(20584514), px(34383777)),
    ],
  },

  // ── Community Helpers ─────────────────────────────────────────────────────
  Doctor: {
    src: px(4021775), backup: px(3279197),
    variations: [
      v('doc-1', 'Doctor', px(4021776), px(3279198)),
      v('doc-2', 'Doctor', px(3279199), px(4021775)),
      v('doc-3', 'Doctor', px(3279197), px(4021776)),
    ],
  },
  Firefighter: {
    src: px(21838999), backup: px(19487945),
    variations: [
      v('fire-1', 'Firefighter', px(2030190),  px(20659632)),
      v('fire-2', 'Firefighter', px(34136296), px(21838999)),
      v('fire-3', 'Firefighter', px(19487945), px(2030190)),
    ],
  },
  Teacher: {
    src: px(5212345), backup: px(5212340),
    variations: [
      v('teach-1', 'Teacher', px(5212346), px(5212341)),
      v('teach-2', 'Teacher', px(5212344), px(5212345)),
      v('teach-3', 'Teacher', px(5212340), px(5212346)),
    ],
  },
  'Police Officer': {
    src: px(19482298), backup: px(29580937),
    variations: [
      v('police-1', 'Police Officer', px(7714710),  px(31584543)),
      v('police-2', 'Police Officer', px(7714736),  px(19482298)),
      v('police-3', 'Police Officer', px(29580937), px(7714710)),
    ],
  },
  Nurse: {
    src: px(6129242), backup: px(5430213),
    variations: [
      v('nurse-1', 'Nurse', px(6129236), px(4930705)),
      v('nurse-2', 'Nurse', px(6129676), px(6129242)),
      v('nurse-3', 'Nurse', px(5430213), px(6129236)),
    ],
  },
  Chef: {
    src: px(3218467), backup: px(784633),
    variations: [
      v('chef-1', 'Chef', px(3218468), px(784634)),
      v('chef-2', 'Chef', px(784633),  px(3218467)),
      v('chef-3', 'Chef', px(3218466), px(3218468)),
    ],
  },
  Dentist: {
    src: px(19879741), backup: px(8413334),
    variations: [
      v('dent-1', 'Dentist', px(19976568), px(6627447)),
      v('dent-2', 'Dentist', px(3881296),  px(19879741)),
      v('dent-3', 'Dentist', px(8413334),  px(19976568)),
    ],
  },
  'Construction Worker': {
    src: px(1216589), backup: px(6268365),
    variations: [
      v('const-1', 'Construction Worker', px(1216590), px(6268366)),
      v('const-2', 'Construction Worker', px(6268365), px(1216589)),
      v('const-3', 'Construction Worker', px(1216588), px(1216590)),
    ],
  },
  Librarian: {
    src: px(11599620), backup: px(9572536),
    variations: [
      v('lib-1', 'Librarian', px(19965435), px(6549850)),
      v('lib-2', 'Librarian', px(9572368),  px(11599620)),
      v('lib-3', 'Librarian', px(9572536),  px(19965435)),
    ],
  },
  Farmer: {
    src: px(30269788), backup: px(29039800),
    variations: [
      v('farm-1', 'Farmer', px(29039798), px(35069661)),
      v('farm-2', 'Farmer', px(7457519),  px(30269788)),
      v('farm-3', 'Farmer', px(29039800), px(29039798)),
    ],
  },

  // ── Verbs ─────────────────────────────────────────────────────────────────
  Run:   {
    src: px(8454909), backup: px(5634121),
    variations: [v('run-v1','Run',px(5634121),null), v('run-v2','Run',px(18408962),null), v('run-v3','Run',px(4604846),null)],
  },
  Sit:   {
    src: px(34599440), backup: px(6615601),
    variations: [v('sit-v1','Sit',px(7602921),null), v('sit-v2','Sit',px(6968099),null), v('sit-v3','Sit',px(9993747),null)],
  },
  Walk:  {
    src: px(4413104), backup: px(3785405),
    variations: [v('walk-v1','Walk',px(10399156),null), v('walk-v2','Walk',px(10399053),null), v('walk-v3','Walk',px(11692911),null)],
  },
  Eat:   {
    src: px(7129440), backup: px(7129430),
    variations: [v('eat-v1','Eat',px(7129522),null), v('eat-v2','Eat',px(7129446),null), v('eat-v3','Eat',px(8430635),null)],
  },
  Sleep: {
    src: px(55639), backup: px(7504928),
    variations: [v('slp-v1','Sleep',px(5801247),null), v('slp-v2','Sleep',px(5801243),null), v('slp-v3','Sleep',px(3887596),null)],
  },
  Jump:  {
    src: px(13545890), backup: px(5488827),
    variations: [v('jmp-v1','Jump',px(15114042),null), v('jmp-v2','Jump',px(1848662),null), v('jmp-v3','Jump',px(2387712),null)],
  },

  // ── Toys ──────────────────────────────────────────────────────────────────
  Ball: {
    src: px(4519856), backup: px(4341110),
    variations: [
      v('ball-1', 'Ball', px(6827970),  px(7123145)),
      v('ball-2', 'Ball', px(26871152), px(4519856)),
      v('ball-3', 'Ball', px(4341110),  px(6827970)),
    ],
  },
  Blocks: {
    src: px(7269700), backup: px(31061855),
    variations: [
      v('blk-1', 'Blocks', px(31061860), px(31061847)),
      v('blk-2', 'Blocks', px(7269687),  px(7269700)),
      v('blk-3', 'Blocks', px(31061855), px(31061860)),
    ],
  },
  Puzzle: {
    src: px(30708395), backup: px(5505122),
    variations: [
      v('pzl-1', 'Puzzle', px(8066783),  px(30708396)),
      v('pzl-2', 'Puzzle', px(27837160), px(30708395)),
      v('pzl-3', 'Puzzle', px(5505122),  px(8066783)),
    ],
  },
  Doll: {
    src: px(31212352), backup: px(31212348),
    variations: [
      v('doll-1', 'Doll', px(26770424), px(20665608)),
      v('doll-2', 'Doll', px(9703989),  px(31212352)),
      v('doll-3', 'Doll', px(31212348), px(26770424)),
    ],
  },
  'Toy Train': {
    src: px(11140406), backup: px(3602695),
    variations: [
      v('ttrn-1', 'Toy Train', px(19734990), px(5818271)),
      v('ttrn-2', 'Toy Train', px(9018266),  px(11140406)),
      v('ttrn-3', 'Toy Train', px(3602695),  px(19734990)),
    ],
  },
  Kite: {
    src: px(29813750), backup: px(36558711),
    variations: [
      v('kite-1', 'Kite', px(16452953), px(33402336)),
      v('kite-2', 'Kite', px(36574265), px(29813750)),
      v('kite-3', 'Kite', px(36558711), px(16452953)),
    ],
  },
  Bubbles: {
    src: px(36767876), backup: px(37638214),
    variations: [
      v('bub-1', 'Bubbles', px(5275849), px(218833)),
      v('bub-2', 'Bubbles', px(2477359), px(36767876)),
      v('bub-3', 'Bubbles', px(37638214), px(5275849)),
    ],
  },
  'Jump Rope': {
    src: px(5275794), backup: px(6339679),
    variations: [
      v('jr-1', 'Jump Rope', px(4945535), px(6339721)),
      v('jr-2', 'Jump Rope', px(6339693), px(5275794)),
      v('jr-3', 'Jump Rope', px(6339679), px(4945535)),
    ],
  },
  Drum: {
    src: px(9509908), backup: px(9644677),
    variations: [
      v('drm-1', 'Drum', px(7715011),  px(9644671)),
      v('drm-2', 'Drum', px(9643915),  px(9509908)),
      v('drm-3', 'Drum', px(9644677),  px(7715011)),
    ],
  },
  'Teddy Bear': {
    src: px(754178), backup: px(35153296),
    variations: [
      v('ted-1', 'Teddy Bear', px(36325284), px(35172082)),
      v('ted-2', 'Teddy Bear', px(35153264), px(754178)),
      v('ted-3', 'Teddy Bear', px(35153296), px(36325284)),
    ],
  },

  // ── Hygiene ───────────────────────────────────────────────────────────────
  Toothbrush: {
    src: px(13466251), backup: px(8191884),
    variations: [
      v('tbr-1', 'Toothbrush', px(7622555),  px(216729)),
      v('tbr-2', 'Toothbrush', px(15694671), px(13466251)),
      v('tbr-3', 'Toothbrush', px(8191884),  px(7622555)),
    ],
  },
  Soap: {
    src: px(13872556), backup: px(7814877),
    variations: [
      v('soap-1', 'Soap', px(7814880),  px(8284369)),
      v('soap-2', 'Soap', px(10221839), px(13872556)),
      v('soap-3', 'Soap', px(7814877),  px(7814880)),
    ],
  },
  Toilet: {
    src: px(7545637), backup: px(6899357),
    variations: [
      v('toil-1', 'Toilet', px(12329135), px(9062351)),
      v('toil-2', 'Toilet', px(4239036),  px(34574604)),
      v('toil-3', 'Toilet', px(6899357),  px(12329135)),
    ],
  },
  Towel: {
    src: px(45980), backup: px(2672634),
    variations: [
      v('twl-1', 'Towel', px(7664063), px(4404976)),
      v('twl-2', 'Towel', px(7691101), px(45980)),
      v('twl-3', 'Towel', px(2672634), px(7664063)),
    ],
  },
  Comb: {
    src: px(7440128), backup: px(5468620),
    variations: [
      v('cmb-1', 'Comb', px(8468165), px(8468151)),
      v('cmb-2', 'Comb', px(7020324), px(8467959)),
      v('cmb-3', 'Comb', px(5468620), px(8468165)),
    ],
  },
  Bandage: {
    src: px(12625109), backup: px(9255018),
    variations: [
      v('bnd-1', 'Bandage', px(31852746), px(9254545)),
      v('bnd-2', 'Bandage', px(9486071),  px(12625109)),
      v('bnd-3', 'Bandage', px(9255018),  px(31852746)),
    ],
  },
  Tissue: {
    src: px(4114026), backup: px(2062424),
    variations: [
      v('tis-1', 'Tissue', px(2292081),  px(3963108)),
      v('tis-2', 'Tissue', px(34689338), px(4114026)),
      v('tis-3', 'Tissue', px(2062424),  px(2292081)),
    ],
  },
  Shampoo: {
    src: px(3735657), backup: px(13516802),
    variations: [
      v('shp-1', 'Shampoo', px(19717724), px(13516803)),
      v('shp-2', 'Shampoo', px(7440056),  px(3735657)),
      v('shp-3', 'Shampoo', px(13516802), px(19717724)),
    ],
  },
  Bathtub: {
    src: px(7020002), backup: px(36671776),
    variations: [
      v('btb-1', 'Bathtub', px(5849409),  px(36845213)),
      v('btb-2', 'Bathtub', px(14996780), px(7020002)),
      v('btb-3', 'Bathtub', px(36671776), px(5849409)),
    ],
  },
  Toothpaste: {
    src: px(14456100), backup: px(25025468),
    variations: [
      v('tp-1', 'Toothpaste', px(12065623), px(7622555)),
      v('tp-2', 'Toothpaste', px(6322805),  px(7622566)),
      v('tp-3', 'Toothpaste', px(25025468), px(12065623)),
    ],
  },

  // ── Nature & Outdoors ─────────────────────────────────────────────────────
  Sun: {
    src: px(301599), backup: px(912364),
    variations: [
      v('sun-1', 'Sun', px(239861), px(189327)),
      v('sun-2', 'Sun', px(9841932), px(301599)),
      v('sun-3', 'Sun', px(912364),  px(239861)),
    ],
  },
  Moon: {
    src: px(5226087), backup: px(12863822),
    variations: [
      v('moon-1', 'Moon', px(30264827), px(10765750)),
      v('moon-2', 'Moon', px(20743548), px(5226087)),
      v('moon-3', 'Moon', px(12863822), px(30264827)),
    ],
  },
  Tree: {
    src: px(33716238), backup: px(34953675),
    variations: [
      v('tree-1', 'Tree', px(1459495),  px(4258)),
      v('tree-2', 'Tree', px(29144666), px(33716238)),
      v('tree-3', 'Tree', px(34953675), px(1459495)),
    ],
  },
  Flower: {
    src: px(29295437), backup: px(165898),
    variations: [
      v('flwr-1', 'Flower', px(33111527), px(35802554)),
      v('flwr-2', 'Flower', px(207975),   px(29295437)),
      v('flwr-3', 'Flower', px(165898),   px(33111527)),
    ],
  },
  Cloud: {
    src: px(5432833), backup: px(8726326),
    variations: [
      v('cld-1', 'Cloud', px(14211384), px(17200685)),
      v('cld-2', 'Cloud', px(13534947), px(5432833)),
      v('cld-3', 'Cloud', px(8726326),  px(14211384)),
    ],
  },
  Rain: {
    src: px(37293704), backup: px(11794234),
    variations: [
      v('rain-1', 'Rain', px(35361500), px(4396960)),
      v('rain-2', 'Rain', px(18554338), px(37293704)),
      v('rain-3', 'Rain', px(11794234), px(35361500)),
    ],
  },
  Grass: {
    src: px(11654274), backup: px(16250442),
    variations: [
      v('grs-1', 'Grass', px(16350863), px(18321682)),
      v('grs-2', 'Grass', px(16543179), px(11654274)),
      v('grs-3', 'Grass', px(16250442), px(16350863)),
    ],
  },
  Mountain: {
    src: px(17609392), backup: px(5922224),
    variations: [
      v('mtn-1', 'Mountain', px(26236200), px(12626252)),
      v('mtn-2', 'Mountain', px(7244),     px(17609392)),
      v('mtn-3', 'Mountain', px(5922224),  px(26236200)),
    ],
  },
  Ocean: {
    src: px(36935286), backup: px(7340129),
    variations: [
      v('ocn-1', 'Ocean', px(13182746), px(36375569)),
      v('ocn-2', 'Ocean', px(36952051), px(36935286)),
      v('ocn-3', 'Ocean', px(7340129),  px(13182746)),
    ],
  },
  Rainbow: {
    src: px(13287185), backup: px(6134011),
    variations: [
      v('rbw-1', 'Rainbow', px(12637742), px(12680259)),
      v('rbw-2', 'Rainbow', px(6134009),  px(13287185)),
      v('rbw-3', 'Rainbow', px(6134011),  px(12637742)),
    ],
  },

  // ── Weather ───────────────────────────────────────────────────────────────
  Sunny: {
    src: px(912364), backup: px(9841932),
    variations: [
      v('snny-1', 'Sunny', px(36551491), px(32951830)),
      v('snny-2', 'Sunny', px(34186382), px(912364)),
      v('snny-3', 'Sunny', px(9841932),  px(36551491)),
    ],
  },
  Rainy: {
    src: px(20359513), backup: px(37293704),
    variations: [
      v('rny-1', 'Rainy', px(459451),   px(11794234)),
      v('rny-2', 'Rainy', px(35361500), px(20359513)),
      v('rny-3', 'Rainy', px(37293704), px(459451)),
    ],
  },
  Cloudy: {
    src: px(8726326), backup: px(14211384),
    variations: [
      v('cldy-1', 'Cloudy', px(17200685), px(13534947)),
      v('cldy-2', 'Cloudy', px(36940521), px(8726326)),
      v('cldy-3', 'Cloudy', px(14211384), px(17200685)),
    ],
  },
  Snowy: {
    src: px(35178453), backup: px(11074105),
    variations: [
      v('snwy-1', 'Snowy', px(10760788), px(10560893)),
      v('snwy-2', 'Snowy', px(10560920), px(35178453)),
      v('snwy-3', 'Snowy', px(11074105), px(10760788)),
    ],
  },
  Windy: {
    src: px(29780143), backup: px(5324555),
    variations: [
      v('wndy-1', 'Windy', px(7226212),  px(30721686)),
      v('wndy-2', 'Windy', px(36560526), px(29780143)),
      v('wndy-3', 'Windy', px(5324555),  px(7226212)),
    ],
  },
  Foggy: {
    src: px(14376357), backup: px(10293072),
    variations: [
      v('fgy-1', 'Foggy', px(32293234), px(9877075)),
      v('fgy-2', 'Foggy', px(15847131), px(14376357)),
      v('fgy-3', 'Foggy', px(10293072), px(32293234)),
    ],
  },
  Stormy: {
    src: px(16277399), backup: px(12372778),
    variations: [
      v('stmy-1', 'Stormy', px(37293704), px(20359513)),
      v('stmy-2', 'Stormy', px(459451),   px(16277399)),
      v('stmy-3', 'Stormy', px(12372778), px(37293704)),
    ],
  },
  Lightning: {
    src: px(15003375), backup: px(15563231),
    variations: [
      v('ltng-1', 'Lightning', px(30683185), px(18584521)),
      v('ltng-2', 'Lightning', px(17610011), px(15003375)),
      v('ltng-3', 'Lightning', px(15563231), px(30683185)),
    ],
  },
  Hail: {
    src: px(34429004), backup: px(8237250),
    variations: [
      v('hail-1', 'Hail', px(10416206), px(35397735)),
      v('hail-2', 'Hail', px(29569107), px(8237250)),
      v('hail-3', 'Hail', px(34429004), px(10416206)),
    ],
  },
  Frost: {
    src: px(326009), backup: px(34839809),
    variations: [
      v('frst-1', 'Frost', px(6609914), px(6757685)),
      v('frst-2', 'Frost', px(6609909), px(326009)),
      v('frst-3', 'Frost', px(34839809), px(6609914)),
    ],
  },
};
